export const REALM_NAME = 'scc';
